import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

import bgSrc from './assets/Ellipse810.png'

export const modal = css`
  position: absolute;
  inset: 0;
  border-radius: 0;
  background-image: url(${bgSrc});
  background-position: bottom right;
  background-repeat: no-repeat;
  background-color: ${cssTheme.default.day.backgroundInvert};
  /* Переопределен цвет крестика закрытия модалки */
  ${cssTheme.default.day.controlMinorText.token}: ${cssTheme.default.day.textInvert};
`

export const body = css`
  overflow-x: hidden;
  background-color: transparent;
  background-image: none;
`

export const image = css`
  flex: 1;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`

export const footer = css`
  background-color: transparent;
`

export const clickMask = css`
  block-size: 44px;
  inline-size: 44px;
  position: absolute;
  z-index: 1;
  inset-block-start: 8px;
  inset-inline-end: 8px;
`
